var map = {
	"./DSC1.jpg": 5354,
	"./DSC2.jpg": 6341,
	"./DSC3.jpg": 5432,
	"./DSC4.jpg": 1915,
	"./DSC5.jpg": 5454,
	"./DSC6.jpg": 7945,
	"./DSC7.jpg": 4220,
	"./DSC8.jpg": 8319,
	"./DSC9.jpg": 1970
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3232;